// MARK: System Stores
import { RouterStore } from "mobx-react-router";
export const routerStore = new RouterStore();
import UIStore from "./_UIStore";
export const uiStore = new UIStore();

// MARK: Stores
import AuthStore from "./AuthStore";
export const authStore = new AuthStore();
import SurveyStore from "./SurveyStore";
export const surveyStore = new SurveyStore();
import BedroomStore from "./BedroomStore";
export const bedroomStore = new BedroomStore();
import BannerStore from "./BannerStore";
export const bannerStore = new BannerStore();
import OfferStore from "./OfferStore";
export const offerStore = new OfferStore();
import RoomStore from "./RoomStore";
export const roomStore = new RoomStore();
import GastroPlaceStore from "./GastroPlaceStore";
export const gastroPlaceStore = new GastroPlaceStore();
import HotelStore from "./HotelStore";
export const hotelStore = new HotelStore();
import GalleryStore from "./GalleryStore";
export const galleryStore = new GalleryStore();
import LanguageStore from "./LanguageStore";
export const languageStore = new LanguageStore();

export const rootStore = {
	routerStore,
	uiStore,
	authStore,

	surveyStore,
	bedroomStore,
	bannerStore,
	offerStore,
	roomStore,
	gastroPlaceStore,
	hotelStore,
	galleryStore,
	languageStore,
};
